// extracted by mini-css-extract-plugin
export default {"modal":"KZjtmj5L_CR2MUoZy67C","content":"Rfp0kj8rbT9PnnQrFoP6"};